import BrandArticle from "@/pages/article/components/BrandArticle";
import { brandArticles } from "@/mocks/brandArticles";

const data = brandArticles.find((a) => a.slug === "cssbuy-spreadsheet")!;

export default function CSSBuySpreadsheetPage() {
  return <BrandArticle data={data} />;
}